import { create } from 'zustand';

interface ServiceVendorStore {
  selectedServiceVendorId: string | null;
  setSelectedServiceVendorId: (id: string | null) => void;

  isEditMode: boolean;
  setEditMode: (isEditing: boolean) => void;

  uploadProgress: number;
  setUploadProgress: (progress: number) => void;
}

export const useServiceVendorStore = create<ServiceVendorStore>((set) => ({
  selectedServiceVendorId: null,
  setSelectedServiceVendorId: (id) => set({ selectedServiceVendorId: id }),

  isEditMode: false,
  setEditMode: (isEditing) => set({ isEditMode: isEditing }),

  uploadProgress: 0,
  setUploadProgress: (progress) => set({ uploadProgress: progress }),
}));
